const myAccountEventType = 'my_account';
var MyAccountMenuPosition;
(function(MyAccountMenuPosition) {
    MyAccountMenuPosition["Header"] = 'Drop-down list';
    MyAccountMenuPosition["Sidebar"] = 'Left list';
})(MyAccountMenuPosition || (MyAccountMenuPosition = {}));

export { MyAccountMenuPosition, myAccountEventType };
//# sourceMappingURL=types.js.map
